<template>
    <v-data-table
        :headers="isMobile ? headers_mobile : headers"
        :items="loan_payment_schedule"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="paginationSync"
        >
            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
            <template v-slot:items="props">
                <tr class="clickable" @click="viewDetails(props.item)" title="Click to view details">
                    <td>{{ props.item.dueOn | moment('MMM DD, YYYY') }}</td>
                    <td>₱{{ numFormat.formatNumber(props.item.amountDue) }}</td>
                    <td>
                        <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                    </td>
                    <td v-if="!isMobile">
                        <span v-if="props.item.processedOn">
                            {{ props.item.processedOn | moment('MMM DD, YYYY') }}
                        </span>
                    </td>
                    <td v-if="!isMobile">
                        <span v-if="props.item.paidOn">
                            {{ props.item.paidOn | moment('MMM DD, YYYY') }}
                        </span>
                    </td>    
                </tr>
            </template>
        </v-data-table> 
</template>

<script>
import numFormat from '@/common/num_format'
import commonfn from '@/common/functions'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'LoanDetails',
    metaInfo: {
        title: 'Loan Payment Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Loan Payment Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    props: ['loan_payment_schedule'],
    components: {},
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            commonfn,
            numFormat,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers: [
                {text: 'Due Date',align: 'left',value: 'dueOn', width: '15%', sortable:true},
                {text: 'Amount Due',align: 'left',value: 'amountDue', width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '15%', sortable:true},
                {text: 'Processed On',align: 'left',value: 'processedOn',  width: '15%', sortable:true},
                {text: 'Paid On',align: 'left',value: 'paidOn',  width: '15%', sortable:true}
            ],
            headers_mobile: [
                {text: 'Due Date',align: 'left',value: 'dueOn', width: '15%', sortable:true},
                {text: 'Amount Due',align: 'left',value: 'amountDue', width: '15%', sortable:true},
                {text: 'Status',align: 'left',value: 'status',  width: '20%', sortable:true}
            ],
        }
    },
    methods: {
        viewDetails(data) {
            this.$router.push(`/finance/loans/schedule/${data.loanScheduleId}`)
        },
    },
    created() {},
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
}
</script>